var _rect, _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVav(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.47656,
    y: 5.02637,
    width: 15.278,
    height: 15.278,
    rx: 1.375,
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.1166,
    cy: 12.6654,
    r: 4.42522,
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7056 12.666L13.4101 12.666M6.52344 12.666L8.81899 12.666",
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1133 17.2574L11.1133 14.5312M11.1133 8.0752L11.1133 10.8182",
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9502 12.6655C12.9502 13.6798 12.128 14.502 11.1138 14.502C10.0995 14.502 9.27734 13.6798 9.27734 12.6655C9.27734 11.6513 10.0995 10.8291 11.1138 10.8291C12.128 10.8291 12.9502 11.6513 12.9502 12.6655Z",
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8867 7.78125H20.8528C21.6122 7.78125 22.2278 8.39686 22.2278 9.15625V16.1749C22.2278 16.9343 21.6122 17.5499 20.8528 17.5499H18.8867V7.78125Z",
    stroke: "#2F3A45",
    strokeWidth: 1.25
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVav);
export default __webpack_public_path__ + "static/media/VAV.e9c82d25d6609d63d32149663901544a.svg";
export { ForwardRef as ReactComponent };